import { SerializedStyles, css } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { ChevronIcon } from 'src/domains/layouts/shared/assets/icons/ChevronIcon';
import { positionElementFull } from 'src/domains/layouts/styles/Mixin.style';
import { Collapse } from 'src/ui/components/collapse/sports/04/Collapse';
import { withConfig } from 'src/withConfig';


export const LiveTrackerToggleWrapper = styled(Collapse, { label: 'LiveTrackerToggleWrapper' })`
    text-transform: capitalize;
`;

const setLiveTrackerIFrameWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.medium};
            background: ${theme.star.liveTracker.bgColor};
            margin-top: 8px;
            @media ${theme.star.mediaQuery.tablet} {
                margin: 8px 8px 0;
                border-radius: ${theme.star.radius.medium};
            }
        `;
    }
    return css``;
};

interface LiveTrackerIFrameWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

export const LiveTrackerIFrameWrapper = withConfig(theme => styled('div', { label: 'LiveTrackerIFrameWrapper' })<LiveTrackerIFrameWrapperPropsType>`
    ${({ variant }): SerializedStyles => setLiveTrackerIFrameWrapper(variant, theme)}
`);

const renderPreMatchBgImage = (bgImage: string | null, theme: EmotionTheme): SerializedStyles => {
    if (bgImage === null ) {
        return css``;
    }

    return css`
        background-color: ${theme.star.preMatch.bgColor};
        &::before {
            ${positionElementFull};
            background-image: url(${bgImage}), ${theme.star.preMatch.bgColorSecondary};
            background-position: top center;
            background-repeat: no-repeat;
            background-size: cover;
            content: '';
            position: absolute;
            z-index: ${theme.star.zIndexGlobal.below};
        }
    `;
};

interface LiveTrackerWrapperType {
    bgImage: string | null;
    isOpen: boolean;
}

/* Background container for Live tracker */
export const LiveTrackerWrapper = withConfig(theme => styled('div', { label: 'LiveTrackerWrapper' })<LiveTrackerWrapperType>`
    height: ${({ isOpen }): string => (isOpen ? '100%' : '0')};
    margin: auto;
    overflow: hidden;
    padding: ${({ isOpen }): string => (isOpen ? '16px 16px 6px' : '0 16px')};
    position: relative;
    text-align: center;
    width: 100%;
    z-index: ${theme.star.zIndexGlobal.base};
    ${({ bgImage }): SerializedStyles => renderPreMatchBgImage(bgImage, theme)};
`);

export const LiveTrackerChevron = styled(ChevronIcon, { label: 'LiveTrackerChevron' })`
    fill: currentcolor;
    width: 12px;
    margin-right: 8px;
`;

interface ReferencePropsType {
    eventId: number;
}

export const ScoreboardWrapper = styled('div', { label: 'ScoreboardWrapper' })<ReferencePropsType>``;
export const SportWidget = styled('div', { label: 'SportWidget' })``; 
